import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { Actions } from '../constants/products/actions';

class ProductsStoreClass extends ReduceStore {
    getInitialState() {
        return [];
    }

    reduce(state, { source, action }) {
        const { type, payload } = action;

        if (source !== ACTION_TYPES.PRODUCTS_ACTION) {
            return state;
        }

        switch (type) {
            case Actions.SET_PRODUCT:
                state = payload;
                break;

            case Actions.ADD_PRODUCT:
                state = [
                    ...state,
                    payload,
                ];
                break;

            case Actions.REMOVE_PRODUCT:
                state = state.filter(product => product.id !== payload);
                break;

            case Actions.UPDATE_PRODUCT:
                state = state.map(product => {
                    if (product.id === payload.id) {
                        return {
                            ...product,
                            ...payload,
                        }
                    }

                    return product;
                })
        }

        return state;
    }
}

const ProductsStore = new ProductsStoreClass(Dispatcher);
export { ProductsStore };
